<template>
  <base-page-layout class="retencao" title="Retenção">
    <v-container fluid class="px-0">
      <retencao-filter :filter.sync="filter" :table-length="listaRetencaoFormatada.length" @updated="getData" />
      <v-card>
        <mf-loading :loader="['retencao', 'categorias-clientes', 'unidades', 'datas-limites']" loader-type="table">
          <v-tabs v-model="tab" grow>
            <v-tab v-for="(item, index) in titles" :key="index">{{ item.title }}</v-tab>
          </v-tabs>
          <v-divider />
          <v-data-table :items="listaRetencaoFormatada" hide-default-footer disable-pagination>
            <template v-slot:header="props">
              <tr>
                <th class="caption">
                  <v-container>
                    <v-layout align-center justify-end>
                      <span class="text-right caption bold primary-text">Período </span>
                      <mf-icon>arrow_right</mf-icon>
                    </v-layout>
                  </v-container>
                  <v-divider />
                  <v-container>
                    <v-layout align-center> <mf-icon>arrow_drop_down</mf-icon><span class="caption bold primary-text">Grupo de 'coorte'</span> </v-layout>
                  </v-container>
                </th>
                <th v-for="(data, index) in retencaoDatas" :key="data" class="caption" :class="{ 'grey-background': index === columnIndex }">
                  <div class="retidos-box">
                    <span class="caption bold primary-text">{{ data | dateMonth }}</span>
                  </div>
                </th>
              </tr>
            </template>
            <template v-slot:item="props">
              <tr>
                <td class="text-center">
                  <div class="group-box">
                    <span class="caption white--text bold">{{ retencaoDatas[props.index] | dateMonth }}</span>
                  </div>
                </td>
                <td
                  v-for="number in props.index"
                  :key="`${number}${props.index}`"
                  :class="{ 'grey-background': number - 1 === columnIndex }"
                  @mouseover="setColumnIndex(number - 1)"
                  @mouseleave="removeColumnIndex()"
                ></td>
                <td
                  v-for="(value, index) in listaRetencaoFormatada.length - props.index"
                  :key="index"
                  class="text-center body-2 bold primary-text"
                  :class="{ 'grey-background': props.index + value - 1 === columnIndex }"
                  @mouseover="setColumnIndex(props.index + value - 1)"
                  @mouseleave="removeColumnIndex()"
                >
                  <span v-if="tab === 0">
                    <retencao-dialog
                      :filter="filter"
                      :object="dadoTabelaValidado(props.index, index)"
                      :first-object="dadoTabelaValidado(props.index, 0)"
                      :date="retencaoDatas[props.index + value - 1]"
                      :group-dates="retencaoDatas[props.index]"
                      :index="value - 1"
                    />
                  </span>
                  <span v-if="tab === 1">{{ dadoTabelaValidado(props.index, index)['PER_RETENCAO'] | localeString(1) | zero | percent }}</span>
                  <span v-if="tab === 2">{{ dadoTabelaValidado(props.index, index)['NUM_CUPONS'] | zero | localeString }}</span>
                  <span v-if="tab === 3">{{ dadoTabelaValidado(props.index, index)['VAL_FATURAMENTO'] | zero | localeString(2) | currency }}</span>
                  <span v-if="tab === 4">{{ dadoTabelaValidado(props.index, index)['VAL_TICKET_MEDIO'] | zero | localeString(2) | currency }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </mf-loading>
      </v-card>
    </v-container>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import RetencaoFilter from '@/modules/clientes/retencao/views/pages/RetencaoFilter.vue'
import RetencaoDialog from '@/modules/clientes/retencao/views/pages/RetencaoDialog.vue'
import { mapState, mapActions } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { head, last, orderBy, groupBy, cloneDeep, floor, capitalize } from 'lodash'
import { DateTime } from 'luxon'

export default {
  components: {
    BasePageLayout,
    RetencaoFilter,
    RetencaoDialog,
  },
  filters: {
    zero(value) {
      if (!value) return 0
      return value
    },
    dateMonth(value) {
      if (!value) return ''
      return capitalize(DateTime.fromFormat(value, 'MM/yyyy').setLocale('pt-BR').toFormat('MMM/yy'))
    },
  },
  data: () => ({
    columnIndex: null,
    filter: {
      date: null,
      scale: 'monthly',
      fidelidade: '',
      tipo_pessoa: '',
      genero: '',
      faixa_etaria: '',
      categoria_cliente: '',
      unidade: null,
      segmentos: null,
    },
    tab: 0,
  }),
  computed: {
    ...mapState({
      listaRetencao: (state) => state.clientes.retencao,
      retencaoDatas: (state) => state.clientes.retencaoDatas,
    }),
    titles() {
      return [{ title: 'Clientes' }, { title: 'Retenção' }, { title: 'Cupons' }, { title: 'Faturamento' }, { title: 'Ticket Médio' }]
    },
    primeiraData() {
      if (!this.retencaoDatas[0]) return
      return head(this.retencaoDatas)[0]
    },
    ultimaData() {
      if (!this.retencaoDatas[0]) return
      return last(this.retencaoDatas)[1]
    },
    listaRetencaoFormatada() {
      let listaAgrupadaGrupoCompra = groupBy(this.listaRetencao, 'NUM_GRUPO_PRIMEIRA_COMPRA')
      let array = []
      for (let indexGrupo in listaAgrupadaGrupoCompra) {
        let localArray = []
        for (let dataIndex in listaAgrupadaGrupoCompra[indexGrupo]) {
          localArray.push(listaAgrupadaGrupoCompra[indexGrupo][dataIndex])
        }
        array.push(orderBy(localArray, 'NUM_DT_COMPRA', 'asc'))
      }
      this.adicionarDadosRetencao(array)
      return array.reverse()
    },
  },
  methods: {
    ...mapActions(['setIsIncludingSegments']),
    ...mapWaitingActions({
      retencao: 'retencao',
    }),
    getData() {
      this.setIsIncludingSegments(false)
      const localFilter = cloneDeep(this.filter)
      this.retencao(localFilter)
    },
    adicionarDadosRetencao(array) {
      array.map((linha) => {
        linha.map((retencao) => {
          retencao['VAL_TICKET_MEDIO'] = retencao['VAL_FATURAMENTO'] / retencao['NUM_CUPONS']
          retencao['PER_RETENCAO'] = floor((retencao['NUM_CLIENTES'] / linha[0]['NUM_CLIENTES']) * 100, 2)
        })
      })
    },
    numeroLinha(index) {
      return this.listaRetencaoFormatada.length - index - 1
    },
    dadoTabelaValidado(index, coluna) {
      let linha = this.numeroLinha(index)
      const item = this.listaRetencaoFormatada[index].find((item) => {
        return item['NUM_GRUPO_PRIMEIRA_COMPRA'] === linha && item['NUM_DT_COMPRA'] === coluna
      })
      if (item) return item
      return {}
    },
    setColumnIndex(index) {
      this.columnIndex = index
    },
    removeColumnIndex() {
      this.columnIndex = null
    },
  },
}
</script>
<style lang="scss">
.retencao {
  .card-title {
    padding-left: 0;
    font-size: 18.5px;
    letter-spacing: 0.2px;
    color: $cinza-d10;
  }
  td {
    &:first-child {
      color: rgba(0, 0, 0, 0.54);
    }
  }
  .return-color {
    color: #fd7e14;
  }
  .group-box {
    background-color: $marca-0;
    border-radius: 3px;
    padding: 4px 16px;
    margin: 8px;
  }
  .retidos-box {
    background-color: $cinza-l80;
    border-radius: 3px;
    padding: 4px 8px;
    text-align: center;
  }
  .v-datatable {
    td,
    th {
      padding: 0 4px !important;
    }
  }
  .grey-background {
    background-color: $cinza-l90;
    transition: background-color 0.1s cubic-bezier(0.25, 0.8, 0.5, 1);
  }
}
</style>
